<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LckmP4/tc-custom/9781611520644.jpg?1723592038361" alt="This image is the cover for the book Double Standard"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Double Standard
      </h1>
      <p class="bookDescription body article font2">
        <p>Executive Jeff Wallace has lusted after Evan Hawthorne since the moment his new employee first stepped into his office for a job interview. Evan is almost ten years Jeff's junior, fresh out of grad school, and one of the best salesmen in the office. Jeff thinks he's hot as hell and as luck would have it, he knows Evan is just as interested.<br/><br/>The only problem? There's a sticky little paragraph in the employee handbook that keeps Jeff from doing anything more than fantasizing about his new employee. The clause that states, in plain English, that managers and their immediate employees cannot fraternize. They can't get together, not even outside the office, just because Jeff's the boss.<br/><br/>Jeff has pleaded with his own supervisor, Kirk Morris, to change the rules. Why shouldn't he? Kirk owns the damn company and spends most of his time bonking Jeff's secretary. But it's a no go ... until Jeff finds himself working late one evening with no one left in the office but Evan, who decides to take matters into his own hands regardless of what the employee manual might say.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J.M. Snyder
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?727fd132